"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VENDOR_CHIME = exports.VENDOR_AGORA = void 0;
var VENDOR_CHIME = exports.VENDOR_CHIME = 'Chime';
var VENDOR_AGORA = exports.VENDOR_AGORA = 'Agora';